import React, { useState } from "react";

interface SearchBarProps {
  onSearch: (term: string) => void;
}

const SearchBar: React.FC<SearchBarProps> = ({ onSearch }) => {
  const [searchTerm, setSearchTerm] = useState("");

  const handleSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    onSearch(searchTerm);
  };

  const handleClear = () => {
    setSearchTerm("");
    onSearch("");
  };

  return (
    <form onSubmit={handleSubmit} className="mb-6">
      <div className="flex shadow-sm rounded-md">
        <input
          type="text"
          placeholder="Search by key or value..."
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
          className="flex-1 px-4 py-2 border border-gray-300 rounded-l-md focus:ring-cyan-500 focus:border-cyan-500"
        />
        {searchTerm && (
          <button
            type="button"
            onClick={handleClear}
            className="px-3 py-2 bg-gray-100 text-gray-700 border-t border-b border-gray-300"
          >
            ✕
          </button>
        )}
        <button
          type="submit"
          className="px-4 py-2 bg-cyan-600 text-white rounded-r-md hover:bg-cyan-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-cyan-500"
        >
          Search
        </button>
      </div>
    </form>
  );
};

export default SearchBar;